import React, { useState, useMemo, useEffect, useRef, lazy, Suspense } from 'react';
import { useCertificatesInfo } from 'staticQueries/certificates-info';
import Container from 'components/UI/Container';
import { withErrorBoundary } from 'components/ErrorBoundary';
import Markup from 'components/Markup';
import IconItem from './IconItem';
import { useStateModal } from 'utils/hooks';
import { replaceKeyword } from 'utils';

import * as styles from './Quotations.module.scss';

const CertificateModal = lazy(() => import('components/Modals/CertificateModal'));

function Quotations({ title, modalsInfo, certificateIDs, list }) {
  const { modalState, showModal, hideModal } = useStateModal();
  const titleRef = useRef(null);
  const [currentId, setCurrentId] = useState(null);

  const openModal = e => {
    setCurrentId(e.target.id);
    showModal();
  };

  const certificates = useCertificatesInfo(certificateIDs);
  const preparedCertificates = useMemo(() => {
    if (certificateIDs) {
      return certificates;
    }

    return list;
  }, [list, certificateIDs]);

  useEffect(() => {
    if (modalsInfo) {
      const ctaLinks = document.querySelectorAll('[href=openModal]');
      if (ctaLinks?.length > 0) {
        ctaLinks.forEach(ctaLink => {
          ctaLink.removeAttribute('href');
          ctaLink.onclick = openModal;
        });
      }
    }
  }, [titleRef.current, modalsInfo]);

  return (
    <Container className={styles.container}>
      <div className={styles.layout}>
        <Markup tag="h2" className={styles.title} ref={titleRef}>
          {replaceKeyword(title)}
        </Markup>
        <div className={styles.icons}>
          {preparedCertificates.map(item => (
            <IconItem key={item.images.preview} {...item} />
          ))}
        </div>
      </div>
      {modalsInfo && currentId && (
        <Suspense fallback={null}>
          <CertificateModal
            isOpen={modalState.isOpen}
            closeModalCallback={hideModal}
            {...modalsInfo[currentId]}
          />
        </Suspense>
      )}
    </Container>
  );
}

Quotations.displayName = 'Quotations';

export default withErrorBoundary(Quotations);
